var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "mb-5" },
    [
      _c("v-card-title", { staticClass: "card-title" }, [
        _vm._v("Dependientes directos"),
      ]),
      _c(
        "v-card-text",
        { staticClass: "pa-6" },
        [
          _c(
            "div",
            { staticClass: "d-flex mb-4" },
            [
              _c("v-spacer"),
              _vm.create_access
                ? _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("addChild")
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("add"),
                      ]),
                      _vm._v("Agregar dependiente"),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-simple-table",
            [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticStyle: { width: "90px" } }, [
                    _vm._v("Orden"),
                  ]),
                  _c("th", [_vm._v("Puesto")]),
                  _c("th", [_vm._v("Responsable")]),
                  _c("th", [_vm._v("Estado")]),
                  _c(
                    "th",
                    {
                      staticClass: "text-center",
                      staticStyle: { width: "140px" },
                    },
                    [_vm._v("Acción")]
                  ),
                ]),
              ]),
              _c(
                "draggable",
                {
                  attrs: {
                    tag: "tbody",
                    handle: ".oc-drag-handle",
                    disabled: !_vm.update_access || _vm.saving_order,
                  },
                  on: { end: _vm.saveOrder },
                  model: {
                    value: _vm.rows,
                    callback: function ($$v) {
                      _vm.rows = $$v
                    },
                    expression: "rows",
                  },
                },
                [
                  _vm._l(_vm.rows, function (child, index) {
                    return _c("tr", { key: child.id }, [
                      _c(
                        "td",
                        [
                          _vm.update_access
                            ? _c(
                                "v-icon",
                                {
                                  staticClass: "oc-drag-handle mr-2",
                                  staticStyle: { cursor: "grab" },
                                  attrs: {
                                    small: "",
                                    title: "Arrastrar para reordenar",
                                  },
                                },
                                [_vm._v("drag_indicator")]
                              )
                            : _vm._e(),
                          _vm._v(" " + _vm._s(index + 1) + " "),
                        ],
                        1
                      ),
                      _c("td", [_vm._v(_vm._s(child.name))]),
                      _c("td", [
                        child.legajo
                          ? _c("span", [
                              _vm._v(
                                _vm._s(child.legajo.name) +
                                  " " +
                                  _vm._s(child.legajo.surname)
                              ),
                            ])
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "font-italic grey--text text--darken-1",
                              },
                              [_vm._v("Sin asignar")]
                            ),
                      ]),
                      _c(
                        "td",
                        [
                          !child.enabled
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "oc-status-chip",
                                  attrs: {
                                    small: "",
                                    color: "grey lighten-3",
                                    "text-color": "grey darken-2",
                                  },
                                },
                                [_vm._v("Inactivo")]
                              )
                            : child.legajo == null
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "oc-status-chip",
                                  attrs: {
                                    small: "",
                                    color: "orange lighten-4",
                                    "text-color": "orange darken-4",
                                  },
                                },
                                [_vm._v("Vacante")]
                              )
                            : _c(
                                "v-chip",
                                {
                                  staticClass: "oc-status-chip",
                                  attrs: {
                                    small: "",
                                    color: "green lighten-4",
                                    "text-color": "green darken-3",
                                  },
                                },
                                [_vm._v("Activo")]
                              ),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                small: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$emit(
                                                    "editChild",
                                                    child
                                                  )
                                                },
                                              },
                                            },
                                            on
                                          ),
                                          [_vm._v("edit")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.update_access ? "Editar" : "Ver")
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _vm.update_access
                                          ? _c(
                                              "v-icon",
                                              _vm._g(
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    small: "",
                                                    color: "orange",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$emit(
                                                        "assignResponsible",
                                                        child
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [_vm._v("person_outline")]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Asignar responsable")])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _vm.delete_access
                                          ? _c(
                                              "v-icon",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "red",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$emit(
                                                        "deleteChild",
                                                        child
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [_vm._v("delete_outline")]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Eliminar")])]
                          ),
                        ],
                        1
                      ),
                    ])
                  }),
                  _vm.rows.length == 0
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center grey--text",
                            attrs: { colspan: "5" },
                          },
                          [_vm._v("El puesto no tiene dependientes.")]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }